<template>
  <h1 class="logo">
    <img src="../assets/logo.svg" alt="사과마켓" />
    <span>사과마켓</span>
  </h1>
</template>
